import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardBody } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import useGetInvReceiveList from '@hooks/INV/InvReceive/useGetInvReceiveList';
import Loading from '@components/Shared/Loader/Loading';
import NtxTable from '@components/DataTable/NtxTable';
import useGetDepreciationList from '@hooks/FixedAssets/useGetDepreciationList';

const Index = () => {
  // const [Show, setShow] = useState(false);
  // const [inventoryId, setInventoryId] = useState("");
  const { t, i18n } = useTranslation();
  const Navigate = useNavigate();
  const { DepreciationList, loading, error } = useGetDepreciationList();

  const columns = [
    { title: t('Number'), key: 'num' },
    { title: t('TransType'), key: 'type' },
    { title: t('Date'), key: 'date' },
    { title: t('الإدارة'), key: 'org' },
    { title: t('الفئة'), key: 'category' },

    { title: t('Status'), key: 'status' },
    { title: t(''), key: 'action', className: 'text-end', sortable: false }
  ];

  const tableData = DepreciationList?.map(item => {
    let rowClass;

    const postedFlagBadge = item.postFlag ? (
      <span className='badge bg-success'>
        <i className='fas fa-check me-1'></i> {/* أيقونة للترحيل */}
        {t('Posted')}
      </span>
    ) : (
      <span className='badge bg-danger'>
        <i className='fas fa-times me-1'></i> {/* أيقونة لعدم الترحيل */}
        {t('NotPosted')}
      </span>
    );

    return {
      org: i18n.language === 'ar' ? item.organizationName2 : item.organizationName,
      num: item.code,
      date: item.transactionDate?.split('T')[0],
      type: i18n.language === 'ar' ? item.transTypeName2 : item.transTypeName,

      category: i18n.language === 'ar' ? item.categoryName2 : item.categoryName,
      status: postedFlagBadge,
      action: (
        <div className='btn-group'>
          <button
            type='button'
            className='btn btn-sm btn-outline-theme'
            // onClick={() => Navigate(`${item.id}/UpdateInvReceive`)}
          >
            <i className='far fa-lg me-2 fa-fw fa-edit'></i>
            {t('Button.Edit')}
          </button>
        </div>
      )
    };
  });

  //________________________________
  const BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome'
    },
    {
      name: 'الإهــلاكات',
      link: null
    }
  ];

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb BreadcrumbList={BcrumbList} PageName='الإهــلاكات' />

        <div className='ms-auto'>
          <Link
            to='AddDepreciation'
            className='btn me-1 btn-theme'

            // onClick={() => setShow(true)}
          >
            <i className='fa fa-plus-circle fa-fw me-1'></i>
            {t('إهلاك جديد')}
          </Link>
        </div>
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>
    </>
  );
};

export default Index;
